// @flow

/**
 * Splits up a large array into smaller arrays.
 */
export default function chunks<T>(items: T[], chunkSize: number): T[][] {
    const chunkArray: T[][] = [];
    let temp: T[] = [];

    for (const [index, item] of items.entries()) {
        temp.push(item);

        if ((index + 1) % chunkSize === 0) {
            chunkArray.push(temp);
            temp = [];
        }
    }

    if (temp.length > 0) {
        chunkArray.push(temp);
    }

    return chunkArray;
}
